// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type Named_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', id: string, name: string };

export type Named_Approval_Fragment = { __typename?: 'Approval', id: string, name: string };

export type Named_BidContract_Fragment = { __typename?: 'BidContract', id: string, name: string };

export type Named_BidContractLineItem_Fragment = { __typename?: 'BidContractLineItem', id: string, name: string };

export type Named_BidItem_Fragment = { __typename?: 'BidItem', id: string, name: string };

export type Named_BidPackage_Fragment = { __typename?: 'BidPackage', id: string, name: string };

export type Named_BidPackageRequest_Fragment = { __typename?: 'BidPackageRequest', id: string, name: string };

export type Named_TradePartner_Fragment = { __typename?: 'TradePartner', id: string, name: string };

export type Named_Bill_Fragment = { __typename?: 'Bill', id: string, name: string };

export type Named_BusinessFunction_Fragment = { __typename?: 'BusinessFunction', id: string, name: string };

export type Named_ChangeEvent_Fragment = { __typename?: 'ChangeEvent', id: string, name: string };

export type Named_ChangeEventLineItem_Fragment = { __typename?: 'ChangeEventLineItem', id: string, name: string };

export type Named_ChangeEventReason_Fragment = { __typename?: 'ChangeEventReason', id: string, name: string };

export type Named_ChangeEventTemplateConfig_Fragment = { __typename?: 'ChangeEventTemplateConfig', id: string, name: string };

export type Named_ChangeRequest_Fragment = { __typename?: 'ChangeRequest', id: string, name: string };

export type Named_ChangeRequestAsset_Fragment = { __typename?: 'ChangeRequestAsset', id: string, name: string };

export type Named_ChangeRequestToDo_Fragment = { __typename?: 'ChangeRequestToDo', id: string, name: string };

export type Named_Client_Fragment = { __typename?: 'Client', id: string, name: string };

export type Named_Cohort_Fragment = { __typename?: 'Cohort', id: string, name: string };

export type Named_SchedulePhase_Fragment = { __typename?: 'SchedulePhase', id: string, name: string };

export type Named_ScheduleSubPhase_Fragment = { __typename?: 'ScheduleSubPhase', id: string, name: string };

export type Named_Task_Fragment = { __typename?: 'Task', id: string, name: string };

export type Named_PlanTask_Fragment = { __typename?: 'PlanTask', id: string, name: string };

export type Named_ToDo_Fragment = { __typename?: 'ToDo', id: string, name: string };

export type Named_Invoice_Fragment = { __typename?: 'Invoice', id: string, name: string };

export type Named_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

export type Named_Region_Fragment = { __typename?: 'Region', id: string, name: string };

export type Named_Market_Fragment = { __typename?: 'Market', id: string, name: string };

export type Named_Community_Fragment = { __typename?: 'Community', id: string, name: string };

export type Named_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

export type Named_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

export type Named_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

export type Named_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type Named_ProjectItem_Fragment = { __typename?: 'ProjectItem', id: string, name: string };

export type Named_Estimate_Fragment = { __typename?: 'Estimate', id: string, name: string };

export type Named_DevelopmentCommitment_Fragment = { __typename?: 'DevelopmentCommitment', id: string, name: string };

export type Named_Commitment_Fragment = { __typename?: 'Commitment', id: string, name: string };

export type Named_Document_Fragment = { __typename?: 'Document', id: string, name: string };

export type Named_Product_Fragment = { __typename?: 'Product', id: string, name: string };

export type Named_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, name: string };

export type Named_JobLogNote_Fragment = { __typename?: 'JobLogNote', id: string, name: string };

export type Named_TradePartnerAvailabilityRequest_Fragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, name: string };

export type Named_PunchlistItemTodo_Fragment = { __typename?: 'PunchlistItemTodo', id: string, name: string };

export type Named_WarrantyTicket_Fragment = { __typename?: 'WarrantyTicket', id: string, name: string };

export type Named_HomeownerContract_Fragment = { __typename?: 'HomeownerContract', id: string, name: string };

export type Named_HomeownerContractChangeOrder_Fragment = { __typename?: 'HomeownerContractChangeOrder', id: string, name: string };

export type Named_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, name: string };

export type Named_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, name: string };

export type Named_GlobalOption_Fragment = { __typename?: 'GlobalOption', id: string, name: string };

export type Named_ProjectCostCode_Fragment = { __typename?: 'ProjectCostCode', id: string, name: string };

export type Named_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, name: string };

export type Named_CostCode_Fragment = { __typename?: 'CostCode', id: string, name: string };

export type Named_CostDivision_Fragment = { __typename?: 'CostDivision', id: string, name: string };

export type Named_Customer_Fragment = { __typename?: 'Customer', id: string, name: string };

export type Named_CustomerOwnerEntity_Fragment = { __typename?: 'CustomerOwnerEntity', id: string, name: string };

export type Named_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, name: string };

export type Named_Development_Fragment = { __typename?: 'Development', id: string, name: string };

export type Named_GlobalOptionTag_Fragment = { __typename?: 'GlobalOptionTag', id: string, name: string };

export type Named_GlobalOptionType_Fragment = { __typename?: 'GlobalOptionType', id: string, name: string };

export type Named_GlobalPlanConstraintItem_Fragment = { __typename?: 'GlobalPlanConstraintItem', id: string, name: string };

export type Named_GlobalPlanMilestone_Fragment = { __typename?: 'GlobalPlanMilestone', id: string, name: string };

export type Named_GlobalPlanTask_Fragment = { __typename?: 'GlobalPlanTask', id: string, name: string };

export type Named_GlobalTask_Fragment = { __typename?: 'GlobalTask', id: string, name: string };

export type Named_HomeownerContractDraw_Fragment = { __typename?: 'HomeownerContractDraw', id: string, name: string };

export type Named_HomeownerSelectionOption_Fragment = { __typename?: 'HomeownerSelectionOption', id: string, name: string };

export type Named_HomeownerSelectionProductOption_Fragment = { __typename?: 'HomeownerSelectionProductOption', id: string, name: string };

export type Named_InternalUser_Fragment = { __typename?: 'InternalUser', id: string, name: string };

export type Named_InvoiceScheduleTemplate_Fragment = { __typename?: 'InvoiceScheduleTemplate', id: string, name: string };

export type Named_Item_Fragment = { __typename?: 'Item', id: string, name: string };

export type Named_ItemSlot_Fragment = { __typename?: 'ItemSlot', id: string, name: string };

export type Named_ItemTemplate_Fragment = { __typename?: 'ItemTemplate', id: string, name: string };

export type Named_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, name: string };

export type Named_Location_Fragment = { __typename?: 'Location', id: string, name: string };

export type Named_MaterialVariantTag_Fragment = { __typename?: 'MaterialVariantTag', id: string, name: string };

export type Named_PandaDoc_Fragment = { __typename?: 'PandaDoc', id: string, name: string };

export type Named_PandaDocRecipient_Fragment = { __typename?: 'PandaDocRecipient', id: string, name: string };

export type Named_PlanMilestone_Fragment = { __typename?: 'PlanMilestone', id: string, name: string };

export type Named_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, name: string };

export type Named_ProjectStageTemplateConfig_Fragment = { __typename?: 'ProjectStageTemplateConfig', id: string, name: string };

export type Named_ProjectStatusChangeReason_Fragment = { __typename?: 'ProjectStatusChangeReason', id: string, name: string };

export type Named_ReadyPlanAggregateVersion_Fragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, name: string };

export type Named_ReadyPlanLocation_Fragment = { __typename?: 'ReadyPlanLocation', id: string, name: string };

export type Named_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', id: string, name: string };

export type Named_ReadyPlanOptionProgramDataModification_Fragment = { __typename?: 'ReadyPlanOptionProgramDataModification', id: string, name: string };

export type Named_Schedule_Fragment = { __typename?: 'Schedule', id: string, name: string };

export type Named_ScheduleTemplate_Fragment = { __typename?: 'ScheduleTemplate', id: string, name: string };

export type Named_Submarket_Fragment = { __typename?: 'Submarket', id: string, name: string };

export type Named_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, name: string };

export type Named_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, name: string };

export type Named_TradeCategory_Fragment = { __typename?: 'TradeCategory', id: string, name: string };

export type Named_TradePartnerContact_Fragment = { __typename?: 'TradePartnerContact', id: string, name: string };

export type Named_TradePartnerMailingList_Fragment = { __typename?: 'TradePartnerMailingList', id: string, name: string };

export type Named_TradePartnerUser_Fragment = { __typename?: 'TradePartnerUser', id: string, name: string };

export type Named_UnitOfMeasure_Fragment = { __typename?: 'UnitOfMeasure', id: string, name: string };

export type Named_User_Fragment = { __typename?: 'User', id: string, name: string };

export type NamedFragment =
  | Named_ScheduleTask_Fragment
  | Named_Approval_Fragment
  | Named_BidContract_Fragment
  | Named_BidContractLineItem_Fragment
  | Named_BidItem_Fragment
  | Named_BidPackage_Fragment
  | Named_BidPackageRequest_Fragment
  | Named_TradePartner_Fragment
  | Named_Bill_Fragment
  | Named_BusinessFunction_Fragment
  | Named_ChangeEvent_Fragment
  | Named_ChangeEventLineItem_Fragment
  | Named_ChangeEventReason_Fragment
  | Named_ChangeEventTemplateConfig_Fragment
  | Named_ChangeRequest_Fragment
  | Named_ChangeRequestAsset_Fragment
  | Named_ChangeRequestToDo_Fragment
  | Named_Client_Fragment
  | Named_Cohort_Fragment
  | Named_SchedulePhase_Fragment
  | Named_ScheduleSubPhase_Fragment
  | Named_Task_Fragment
  | Named_PlanTask_Fragment
  | Named_ToDo_Fragment
  | Named_Invoice_Fragment
  | Named_StandaloneProject_Fragment
  | Named_Region_Fragment
  | Named_Market_Fragment
  | Named_Community_Fragment
  | Named_Subdivision_Fragment
  | Named_Lot_Fragment
  | Named_Structure_Fragment
  | Named_Unit_Fragment
  | Named_ProjectItem_Fragment
  | Named_Estimate_Fragment
  | Named_DevelopmentCommitment_Fragment
  | Named_Commitment_Fragment
  | Named_Document_Fragment
  | Named_Product_Fragment
  | Named_ItemTemplateItemVersion_Fragment
  | Named_JobLogNote_Fragment
  | Named_TradePartnerAvailabilityRequest_Fragment
  | Named_PunchlistItemTodo_Fragment
  | Named_WarrantyTicket_Fragment
  | Named_HomeownerContract_Fragment
  | Named_HomeownerContractChangeOrder_Fragment
  | Named_ReadyPlan_Fragment
  | Named_PlanPackage_Fragment
  | Named_GlobalOption_Fragment
  | Named_ProjectCostCode_Fragment
  | Named_CommitmentChangeOrder_Fragment
  | Named_CostCode_Fragment
  | Named_CostDivision_Fragment
  | Named_Customer_Fragment
  | Named_CustomerOwnerEntity_Fragment
  | Named_DesignPackage_Fragment
  | Named_Development_Fragment
  | Named_GlobalOptionTag_Fragment
  | Named_GlobalOptionType_Fragment
  | Named_GlobalPlanConstraintItem_Fragment
  | Named_GlobalPlanMilestone_Fragment
  | Named_GlobalPlanTask_Fragment
  | Named_GlobalTask_Fragment
  | Named_HomeownerContractDraw_Fragment
  | Named_HomeownerSelectionOption_Fragment
  | Named_HomeownerSelectionProductOption_Fragment
  | Named_InternalUser_Fragment
  | Named_InvoiceScheduleTemplate_Fragment
  | Named_Item_Fragment
  | Named_ItemSlot_Fragment
  | Named_ItemTemplate_Fragment
  | Named_ItemTemplateItem_Fragment
  | Named_Location_Fragment
  | Named_MaterialVariantTag_Fragment
  | Named_PandaDoc_Fragment
  | Named_PandaDocRecipient_Fragment
  | Named_PlanMilestone_Fragment
  | Named_ProductOffering_Fragment
  | Named_ProjectStageTemplateConfig_Fragment
  | Named_ProjectStatusChangeReason_Fragment
  | Named_ReadyPlanAggregateVersion_Fragment
  | Named_ReadyPlanLocation_Fragment
  | Named_ReadyPlanOption_Fragment
  | Named_ReadyPlanOptionProgramDataModification_Fragment
  | Named_Schedule_Fragment
  | Named_ScheduleTemplate_Fragment
  | Named_Submarket_Fragment
  | Named_TakeoffLineItem_Fragment
  | Named_TakeoffLineItemVersion_Fragment
  | Named_TradeCategory_Fragment
  | Named_TradePartnerContact_Fragment
  | Named_TradePartnerMailingList_Fragment
  | Named_TradePartnerUser_Fragment
  | Named_UnitOfMeasure_Fragment
  | Named_User_Fragment
;

export type DisplayNamed_BidItem_Fragment = { __typename?: 'BidItem', id: string, displayName: string };

export type DisplayNamed_ChangeEventLineItem_Fragment = { __typename?: 'ChangeEventLineItem', id: string, displayName: string };

export type DisplayNamed_ProjectItem_Fragment = { __typename?: 'ProjectItem', id: string, displayName: string };

export type DisplayNamed_Commitment_Fragment = { __typename?: 'Commitment', id: string, displayName: string };

export type DisplayNamed_Document_Fragment = { __typename?: 'Document', id: string, displayName: string };

export type DisplayNamed_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, displayName: string };

export type DisplayNamed_ReadyPlan_Fragment = { __typename?: 'ReadyPlan', id: string, displayName: string };

export type DisplayNamed_PlanPackage_Fragment = { __typename?: 'PlanPackage', id: string, displayName: string };

export type DisplayNamed_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', id: string, displayName: string };

export type DisplayNamed_CostCode_Fragment = { __typename?: 'CostCode', id: string, displayName: string };

export type DisplayNamed_CostDivision_Fragment = { __typename?: 'CostDivision', id: string, displayName: string };

export type DisplayNamed_DesignPackage_Fragment = { __typename?: 'DesignPackage', id: string, displayName: string };

export type DisplayNamed_Item_Fragment = { __typename?: 'Item', id: string, displayName: string };

export type DisplayNamed_ItemTemplate_Fragment = { __typename?: 'ItemTemplate', id: string, displayName: string };

export type DisplayNamed_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, displayName: string };

export type DisplayNamed_ProductOffering_Fragment = { __typename?: 'ProductOffering', id: string, displayName: string };

export type DisplayNamed_ReadyPlanAggregateVersion_Fragment = { __typename?: 'ReadyPlanAggregateVersion', id: string, displayName: string };

export type DisplayNamed_ReadyPlanOption_Fragment = { __typename?: 'ReadyPlanOption', id: string, displayName: string };

export type DisplayNamed_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, displayName: string };

export type DisplayNamed_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, displayName: string };

export type DisplayNamed_TradeCategory_Fragment = { __typename?: 'TradeCategory', id: string, displayName: string };

export type DisplayNamedFragment =
  | DisplayNamed_BidItem_Fragment
  | DisplayNamed_ChangeEventLineItem_Fragment
  | DisplayNamed_ProjectItem_Fragment
  | DisplayNamed_Commitment_Fragment
  | DisplayNamed_Document_Fragment
  | DisplayNamed_ItemTemplateItemVersion_Fragment
  | DisplayNamed_ReadyPlan_Fragment
  | DisplayNamed_PlanPackage_Fragment
  | DisplayNamed_CommitmentChangeOrder_Fragment
  | DisplayNamed_CostCode_Fragment
  | DisplayNamed_CostDivision_Fragment
  | DisplayNamed_DesignPackage_Fragment
  | DisplayNamed_Item_Fragment
  | DisplayNamed_ItemTemplate_Fragment
  | DisplayNamed_ItemTemplateItem_Fragment
  | DisplayNamed_ProductOffering_Fragment
  | DisplayNamed_ReadyPlanAggregateVersion_Fragment
  | DisplayNamed_ReadyPlanOption_Fragment
  | DisplayNamed_TakeoffLineItem_Fragment
  | DisplayNamed_TakeoffLineItemVersion_Fragment
  | DisplayNamed_TradeCategory_Fragment
;

export const NamedFragmentDoc = gql`
    fragment Named on Named {
  id
  name
}
    `;
export const DisplayNamedFragmentDoc = gql`
    fragment DisplayNamed on HasDisplayName {
  id
  displayName
}
    `;